/**
 * WHO MAY SEE THE BOOKS.
 *
 * Anthony, 2026-10-07: "me and Alaina only can see this."
 *
 * Two profile ids, not a role. Admin is the wrong test here: Nina is an
 * admin on the Supercanic account and this is the owners' money, not the
 * shop's. The page reads this list to decide whether to draw the row; the
 * server reads the SAME list in server/routes/books.ts before it answers,
 * because a hidden row is not a lock.
 *
 * Adding a person is adding a line here and deploying. That is on purpose.
 */
import { SUPERCANIC_ACCOUNT } from "./review-links.ts";

export const BOOKS_VIEWERS: ReadonlySet<string> = new Set([
  "f87cafe2-cea1-4436-8536-492be3047f4f", // Anthony Limpert
  "e154e5b4-2f82-4587-bcf3-3599f0ac3201", // Alaina Limpert
]);

export const canSeeBooks = (profileId: string | null | undefined): boolean =>
  !!profileId && BOOKS_VIEWERS.has(profileId);

/**
 * WHO MAY SEE THE ACCOUNTING PAGE. The same two people, and only while
 * they are sitting in the Supercanic shop.
 *
 * Anthony, 2026-10-08: "just for us two." The page reads one shop's live
 * payments, invoices and jobs, so it is the shop's money and not the
 * company's. Anthony is the platform owner and switch_shop moves his
 * profile between tenants; when he is standing in another shop the page
 * would otherwise be showing Supercanic's money inside somebody else's
 * desk. So both halves have to hold: the person is on the list AND the
 * shop they are in right now is Supercanic. The server checks both again
 * in server/routes/accounting.ts, reading the account off the profile row
 * rather than anything the browser sent.
 */
export const ACCOUNTING_SHOP = SUPERCANIC_ACCOUNT;

export const canSeeAccounting = (
  profileId: string | null | undefined,
  accountId: string | null | undefined,
): boolean => canSeeBooks(profileId) && accountId === ACCOUNTING_SHOP;
